module.exports = __webpack_public_path__ + "static/media/dashboard.7ab883bd.svg";